const palette = {
    //   colors
    night: '#161619', white: '#F3F2F9', navy: '#18076F', secondary: "gray",
    pop: '#9933FF', blue: '#3333CC', positive: '#118D57', primary: "#7635DD", primaryBg: "#E9DFF9",
    positiveBg: '#DBF6E5', negative: '#D03F18', negativeBg: '#FFE4DE',
    neutral: '#FEAB01', neutralBg: '#FFF1D6', callInbound: '#6366F1',
    callOutbound: '#B9BEC9', calls: '#6366F1', callsBg: '#E9EFFC',
    helpful: '#91CC75', happy: '#91CC75', emotional: '#FFDC60',
    slow: '#ffe9a8ff', professional: '#6366F1', confused: '#7C7FFF',
    satisfied: '#91CC75', frustrated: '#EE6666', angry: '#EE6666', agent: '#0891B2', agentBg: '#e1f9ffff', superAdmin: '#F73A7A', superAdminBg: '#ffd2e1ff',
    campaign1: '#F73A7A', campaign2: '#F73A7A', averageHandlingTime: '#7C7FFF', sky: "#5c92f6ff",
    totalCallVolume1: '#91CC75', totalCallVolume2: '#91CC75', totalCallVolumeBg: '#91CC75',
    agentCallVolume: '#6366F1', callDroptrend: '#EE6666', disposition: '#91CC75',
    subDisposition: '#FFDC60', scrollThumb: '#7c7fffff',
    rank1Bg: '#FFF9C4', rank2Bg:'#E6FFF9',rank3Bg:'#FFEACC',
    rank1Border : '#E0D6FF', rank2Border : '#FFF9C4', rank3Border : '#FFEACC'
};





// typographys

const typography = {
    fontStack: `'Sora', system-ui, sans-serif`,
    fsHero: '3.5rem',
    fsH1: '2.5rem',
    fsH2: '2rem',
    fsH3: '1.5rem',
    fsBody: '1rem',
    fsSmall: '0.875rem',
    fwThin: 100,
    fwLight: 300,
    fwRegular: 400,
    fwMedium: 500,
    fwSemibold: 600,
    fwBold: 700,
};

// spacing
const spacing = {
    xs: '0.5rem',
    s: '1rem',
    m: '1.5rem',
    l: '2rem',
    xl: '3rem',
    radius: '8px',
    shadow: '0 4px 12px rgba(22,22,25,.08)',
};
    
// combine all 
export const theme = (section, key) => {
    const map = { palette, typography, spacing }[section];
    if (!map) throw new Error(`Unknown section "${section}"`);
    const value = map[key];
    if (!value && value !== 0) throw new Error(`Unknown key "${key}" in ${section}`);


    const classSection = section === 'palette' ? `text-${key} bg-${key}` :
        section === 'typography' ?
            (key.startsWith('fs') ? key : key.startsWith('fw') ? key : 'font-sora') : key;

    return {
        className: classSection,
        value,
        style: section === 'palette' ? { color: value, backgroundColor: value } :
            section === 'typography' ?
                (key.startsWith('fs') ? { fontSize: value } :
                    key.startsWith('fw') ? { fontWeight: value } : { fontFamily: value }) :
                { padding: value, margin: value },
    };
};



export { palette, typography, spacing };